import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from "@auth0/auth0-react";
import {apiVersion, identityServer} from "./components/Context/IDContext";

ReactDOM.render(
  <React.StrictMode>
      <Auth0Provider
          domain="spotai.auth0.com"
          clientId="LwERRfdbDX63efWL8HRxI4PkiRD3liUq"
          redirectUri={window.location.origin}
          audience="https://provision.spotai.co"
          scope="openid profile email read:deviceStatus read:deviceType read:identities read:identityStatus read:logs write:deviceType"
      >
        <App />
      </Auth0Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
